import { render, staticRenderFns } from "./CreateNewTemplateModal.vue?vue&type=template&id=d86d6dfa&"
import script from "./CreateNewTemplateModal.vue?vue&type=script&lang=js&"
export * from "./CreateNewTemplateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports